import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./Style/global.css";
import "./Style/variable.css";
import Menu from "./Component/Menu";
import LoginPage from "./Pages/LoginPage";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Style/Component/Toast.css";
import LandingPage from "./Pages/LandingPage";
import Terms from "./Component/Terms";
import PrivacyPolicy from "./Component/PrivacyPolicy";

function App() {
  const auth = useSelector((state) => state.auth);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/admin/login" element={!auth?.token ? <LoginPage /> : <Navigate to="/admin" />} />
        <Route path="/admin/*" element={auth?.token ? <Menu /> : <Navigate to="/admin/login" />} />
        {/* Redirect any other /admin path to /admin if logged in, or /admin/login if not */}
        <Route path="/login" element={<Navigate to="/admin/login" />} />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        newestOnTop
        theme="light"
        className="custom-toast-container"
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
      />
    </BrowserRouter>
  );
}

export default App;
